
import React, { useState } from "react";
import {
  Table,
  Input,
  Spin,
  Space,
  Button
} from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { ZoomInOutlined, FileAddOutlined } from "@ant-design/icons";
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import EndorsementInfo from "./EndorsementInfo";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";

const { Search } = Input;

export default function IssueEndorsementTable() {
  const reports = useReportsStore()
  const general = useGeneralStore();
  const { auth } = usePersistedStore();
  const [filterText, setFilterText] = useState("");
  const issueEndorsement = reports.issueEndorsement.data.DetailReport;
  const userInfoResources = auth.userInfo.Resources;
  const data = reports.issueEndorsement.filtered;
  const loading = reports.issueEndorsement.loading;

  const [requestId, setRequestId] = useState();
  const [endorsementId, setEndorsementId] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,

    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "جزئیات بیمه نامه",
      dataIndex: "operation",
      key: "operation",
      width: 85,
      render: (_, record) =>
        issueEndorsement.length >= 1 && (
          <Space size="middle">
            <Button type='link' onClick={() => {
              reports.getInsuranceDetailsInfo(record.InsuranceRequestId)
              setRequestId(record.InsuranceRequestId);
              general.ToggleInsuranceDetailsModal();
            }
            }><ZoomInOutlined /></Button>
          </Space>
        ),
    },
    {
      title: "جزئیات الحاقیه",
      dataIndex: "endorsementOperation",
      key: "endorsementOperation",
      width: 80,
      render: (_, record) =>
        issueEndorsement.length >= 1 && (
          <Space size="middle">
            <Button type='link' onClick={() => {
              reports.getEndorsementDetailsInfo(record.EndorsementId)
              setEndorsementId(record.EndorsementId);
              general.ToggleEndorsementDetailsModal();
            }
            }><FileAddOutlined /></Button>
          </Space>
        ),
    },
    {
      title: "نام بیمه گزار",
      dataIndex: "Insurer",
      key: "Insurer",
      width: 150,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.Insurer ? (first = a.Insurer) : (first = "");
        b.Insurer ? (second = b.Insurer) : (second = "");
        return first.localeCompare(second);
      },
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
      title: "نام کاربر",
      dataIndex: "ApplicantFullName",
      key: "ApplicantFullName",
      width: 120,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.ApplicantFullName ? (first = a.ApplicantFullName) : (first = "");
        b.ApplicantFullName ? (second = b.ApplicantFullName) : (second = "");
        return first.localeCompare(second);
      },
      render: text => text && strings.getFarsiNum(text),
    },
    {
      title: "نام بازاریاب",
      dataIndex: "PromoterFullName",
      key: "PromoterFullName",
      width: 110,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.PromoterFullName ? (first = a.PromoterFullName) : (first = "");
        b.PromoterFullName ? (second = b.PromoterFullName) : (second = "");
        return first.localeCompare(second);
      },

    },

    {
      title: "رشته",
      dataIndex: "BranchTitle",
      key: "BranchTitle",
      width: 100,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.BranchTitle ? first = a.BranchTitle : first = '';
        b.BranchTitle ? second = b.BranchTitle : second = '';
        return first.localeCompare(second)
      },
    },
    {
      title: "کارمزد",
      dataIndex: "BusinessWageAmount",
      key: "BusinessWageAmount",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ الحاقیه",
      dataIndex: "Amount",
      key: "Amount",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ پرداختی",
      dataIndex: "SumPayment",
      key: "SumPayment",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ مالیات",
      dataIndex: "TaxAmount",
      key: "TaxAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "تخفیفات",
      dataIndex: "SumDiscountAmount",
      key: "SumDiscountAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "عودت",
      dataIndex: "ReturnToUser",
      key: "ReturnToUser",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "شرکت بیمه",
      dataIndex: "CompanyName",
      key: "CompanyName",
      width: 120,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.CompanyName ? first = a.CompanyName : first = '';
        b.CompanyName ? second = b.CompanyName : second = '';
        return first.localeCompare(second)
      },
    },
    {
      title: "کدالحاقیه",
      dataIndex: "EndorsementId",
      key: "EndorsementId",
      ellipsis: true,
      width: 80,
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "کد درخواست",
      dataIndex: "InsuranceRequestId",
      key: "InsuranceRequestId",
      ellipsis: true,
      width: 80,
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "تاریخ صدور",
      dataIndex: "IssueDate",
      key: "IssueDate",
      width: 130,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.IssueDate ? first = a.IssueDate : first = '';
        b.IssueDate ? second = b.IssueDate : second = '';
        return first.localeCompare(second)
      },
      render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')),
    },

  ];
  const handleSearchFilter = (e) => {
    setFilterText(e.target.value);
    issueEndorsement && reports.filterIssueEndorsement({ value: e.target.value })
  }
  const handleClick = () => {
    reports.getBusinessCommissionsMultiple(selectedRowKeys);
    setSelectedRowKeys([]);
  };

  return (
    <>
      <Spin spinning={loading}>
        <div dir="rtl">
          <Search
            className="table-search"
            placeholder="جستجو بر اساس نام بیمه گزار ، نام کاربر ، رشته ، شرکت بیمه"
            onChange={handleSearchFilter}
          />
        </div>
        <button type="primary" className="btn btn-primary waves-effect waves-light"
          style={{ marginBottom: "-1rem" }}
          onClick={handleClick}
          htmltype="submit"
          disabled={!selectedRowKeys.length > 0}>
          محاسبه مجدد کارمزد
        </button>
        <Table
          style={{ overflowX: 'scroll' }}
          className="custom-table row-selection"
          size="small"
          bordered
          columns={userInfoResources &&
            (userInfoResources.includes("BusinessSaleReport") ||
              userInfoResources.includes("BusinessSupportReport")) ?
            columns : (columns.filter(col => col.dataIndex !== 'operation'))}
          rowKey="InsuranceRequestId"
          rowSelection={rowSelection}
          dataSource={filterText ? data : issueEndorsement}
          scroll={true}
        />
        <InsuranceDetails requestId={requestId} />
        <EndorsementInfo endorsementId={endorsementId} />
      </Spin>
    </>
  );
}